import { KeyValueList, type KeyValue } from './KeyValueList';
import { Panel } from './Panel';

/** A box titled "Customer Information" / "Agent Information" / "Carrier Information" with label and value rows */
export const InfoPanel = ({ title, rows }: { title: string; rows: KeyValue[] }) => (
  <Panel title={title}>
    <KeyValueList rows={rows} />
  </Panel>
);
